import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorMessageService {
  public messageNotification = new Subject<string>();

  /**
   * display error messaging from the API
   */
  public displayErrorMessage(error: HttpErrorResponse) {
    let message = `An error has occurred (${error.status}).`;

    if (typeof error.error['non_field_errors'] !== 'undefined') {
      if (error.error['non_field_errors'].length > 0) {
        message = error.error['non_field_errors'][0].message;
      }
    }
    if (typeof error.error['field_errors'] !== 'undefined') {
      if (error.error['field_errors'].length > 0) {
        message = error.error['field_errors'][0].message;
      }
    }

    this.messageNotification.next(message);
  }
}
